<template>
  <v-card round outlined elevation='6' class="seat" :class="getCssClass()" @mouseover="hovered=true" @mouseleave="hovered=false">
    <v-card-text class="no-pad">
      <div class="poker-cards" v-if="showCards()">
        <template v-if="visibleCards.length > 0">
          <poker-card class="card" v-for="card in player.cards" :key="card" :card="card">
          </poker-card>
          <!-- if had some hidden some not, show the others with backs -->
          <poker-card class="card" v-for="k in (numCards() - visibleCards.length)" :key="k" card="card-back">
          </poker-card>
        </template>
        <template v-else>
          <poker-card class="card" v-for="k in numCards()" :key="k" card="card-back">
          </poker-card>
        </template>
      </div>
      <div class="dealer" v-if="isDealer()">D</div>
      <div class="name">{{ player.name }}</div>
      <div class="action" v-if="getAction()">{{ getAction() }}</div>
      <div :class="needsToLeave()">{{ getStack() }}</div>
      <div v-if="player.sitout">(sitting out)</div>
      <div class="chips" v-if="player.chips">{{ getChips() }}</div>
    </v-card-text>
  </v-card>
</template>

<script>

import Card from '../PokerCard.vue';

export default {
  components: {
    'poker-card': Card
  },
  props: {
    player: Object,
    state: Object
  },
  data() {
    return {
      hovered: false
    };
  },
  computed: {
    visibleCards() {
      return this.player.cards.filter((el) => {
        return el ? true : false;
      })
    },
  },
  methods: {
    getStack() {
      let player = this.player;
      let stack = player.stack;
      let d = this.getDivider();
      return (stack / d).toFixed(2);
    },
    isDealer() {
      // if state has dealer seat we use this
      if (this.state.dealer_seat !== undefined) {
        return this.player.seat === this.state.dealer_seat;
      }

      // otherwise use tableInit (pkr2)
      var e;
      try {
        e = this.state.room.tableInit.events[0];
      } catch (err) {
        console.log("failed to get table init");
        return false;
      }
      return e.dealerSeat === this.player.seat;
    },
    getChips() {
      let player = this.player;
      let d = this.getDivider();
      return (player.chips / d).toFixed(2);
    },
    getAction() {
      let player = this.player;
      if (!this.state.hand_state) {
        return '';
      }
      let moves = this.state.hand_state.moves;
      var action = '';
      var folded = false;
      for (var k in moves) {
        let move = moves[k];
        //console.log(move.seat, player.seat, move.seat === player.seat);
        if (move.type === 'flop' || move.type === 'turn' || move.type === 'river') {
          action = '';
        } else if (move.seat == player.seat) {
          if (move.type == 'fold') {
            folded = true;
          }
          action = move.type;
        }
      }
      if (folded) {
        return 'fold'
      }
      if (action === '') {
        return false;
      }
      return action;
    },
    showCards() {
      let st = this.state.room.status;
      if (st === 'WAITING' || st === 'PREPARE') return false;
      let act = this.getAction();
      let n = this.player.cards.length;
      if (n > 0 && this.hovered) return true;
      if (act === 'fold') return false;
      if (!this.inHand()) return false;
      return true;
    },
    inHand() {
      if ('in_hand' in this.player) {
        // this will tell us if player is in the hand
        return this.player.in_hand;
      }

      // look on tableInit if we don't have from here
      var e;
      try {
        e = this.state.room.tableInit.events[0];
      } catch (err) {
        // if we cant get the table init events assume in hand
        return true;
      }
      let seats = e.seatStates;
      let pid = this.player.id;
      for (let s of seats) {
        if (s.id === pid) return true;
      }
      return false;
    },
    getCssClass() {
      let player = this.player;
      var target_seat = player.seat;
      if (this.state.player_id) {
        let _id = this.state.player_id;
        for (var k in this.state.players) {
          let p = this.state.players[k];
          if (p.id === _id) {
            target_seat = (11 + player.seat - p.seat) % 11;
            break
          }
        }
      }
      var css = "seat-" + target_seat;
      // console.log(this.state.active_seat);
      if (this.state.active_seat === player.seat) {
        css += " active";
      }
      return css;
    },
    needsToLeave() {
      let player = this.player;
      let bb = this.state.settings.bb;
      let other_high = 0;
      let our_stack = player.stack;
      if (this.state.player_id) {
        let _id = this.state.player_id;
        for (var k in this.state.players) {
          let p = this.state.players[k];
          if (p.id !== _id && p.stack > other_high) {
            other_high = p.stack;
          }
        }
      }

      if (player.id == this.state.player_id && our_stack > 400 * bb && other_high > 400 * bb) {
        return "need-leave";
      }
      return '';
    },
    getDivider() {
      if (!this.state || !this.state.settings) {
        return 1;
      }
      let s = this.state.settings;
      if (s.withDecimal) {
        return 100;
      }
      return 1;
    },
    numCards() {
      if (!this.state.settings.omaha) {
        return 2;
      }
      if (this.state.settings._6Cards) {
        return 6;
      }
      if (this.state.settings._5Cards) {
        return 5;
      }
      return 4;
    }
  }
}
</script>

<style scoped>
.seat {
  width: 110px;
  text-align: center;
}

.active {
  background-color: rgb(134, 134, 134) !important;
}

.need-leave {
  color: red;
}

.dealer {
  display: flex;
  position: absolute;
  border-radius: 10px;
  padding-left: 5px;
  font-weight: bold;
  color: white;
  width: 20px;
  border: white 1px solid;
  background-color: black;
}

.seat-0 .dealer {
  top: 0px;
  left: 95px;
}

.seat-1 .dealer, .seat-2 .dealer, .seat-3 .dealer, .seat-4 .dealer {
  top: 50px;
  left: 110px;
}

.seat-5 .dealer {
  top: 50px;
  left: 100px;
}

.seat-6 .dealer, .seat-7 .dealer, .seat-8 .dealer, .seat-9 .dealer, .seat-10 .dealer {
  top: 50px;
  left: -20px;
}

.chips {
  color: black;
  font-weight: bold;
  background-color: cyan;
  background-blend-mode: difference;
  border: 2px solid black;
  border-radius: 20px;
  padding: 4px;
  display: flex;
  position: absolute;
}

.seat-0 .chips {
  left: 40px;
  top: -60px;
}


.seat-1 .chips {
  left: 120px;
  top: 0px;
}

.seat-2 .chips {
  left: 120px;
  top: 20px;
}

.seat-3 .chips {
  left: 120px;
  top: 20px;
}

.seat-4 .chips {
  left: 120px;
  top: 20px;
}

.seat-5 .chips {
  left: 60px;
  top: 80px;
}

.seat-6 .chips {
  left: -10px;
  top: 80px;
}

.seat-7 .chips {
  left: -50px;
  top: 20px;
}

 .seat-8 .chips {
   left: -50px;
   top: 20px
 }

.seat-9 .chips {
  left: -50px;
  top: 20px;
}

.seat-10 .chips {
  left: -50px;
  top: -10px;
}


.seat-0 {
  position: absolute;
  top: 580px;
  left: 150px;
}

.seat-1 {
  position: absolute;
  top: 480px;
  left: 0px;
}

.seat-2 {
  position: absolute;
  top: 380px;
  left: 0px;
}

.seat-3 {
  position: absolute;
  top: 230px;
  left: 0px;
}

.seat-4 {
  position: absolute;
  top: 110px;
  left: 0px;
}

.seat-5 {
  position: absolute;
  top: 0px;
  left: 60px;
}

.seat-6 {
  position: absolute;
  top: 5px;
  left: 250px;
}

.seat-7 {
  position: absolute;
  top: 115px;
  left: 300px;
}

.seat-8 {
  position: absolute;
  top: 230px;
  left: 300px;
}

.seat-9 {
  position: absolute;
  top: 380px;
  left: 300px;
}

.seat-10 {
  position: absolute;
  top: 500px;
  left: 300px;
}


.poker-cards {
  position: absolute;
  top: -24px;
  left: 0px;
  margin-bottom: -30px;
  display: flex;
  width: 160px;
}

.card {
  display: inline-flex;
  margin-left: 2px !important;
}

.no-pad {
  padding: 4px;
}

.name {
  margin-top: 16px;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
